import { SkipLink } from "@/common/components/SkipLink";
import { SRAnnouncementProvider } from "@/state/providers/SRAnnouncementProvider";

type Props = {
    children: React.ReactNode;
};

/**
 * Layout wrapper for unauthenticated routes.
 * Provides accessibility features (skip link, screen reader announcements).
 */
export function UnAuthenticatedLayout({ children }: Props) {
    return (
        <>
            <SkipLink />
            <SRAnnouncementProvider>
                <main id="main-content">{children}</main>
            </SRAnnouncementProvider>
        </>
    );
}

export default UnAuthenticatedLayout;
